import PropTypes from "prop-types";
import ErrorInput from "../ui/ErrorInput";

export const InputFecha = ({ label, id, formik }) => {
  return (
    <div>
      <div className="d-flex justify-content-between">
        <label htmlFor={id}>{label}</label>
        {formik.errors[id] !== undefined && formik.touched[id] !== undefined && <ErrorInput touched={formik.touched[id]} error={formik.errors[id]} />}
      </div>

      <input
        type="date"
        name={id}
        id={id}
        className="form-control"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[id]}
      />
    </div>
  );
};

InputFecha.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  formik: PropTypes.object.isRequired,
};
